export const HOME_H1 =
	'TERAPIA ONLINE: Seu psicólogo a qualquer hora, em qualquer lugar.'

export const FAQ_H1 =
	'Dúvidas sobre Psicologia, Terapia Online, Agendamentos e muito mais'

export const ABOUT_H1 = 'Conheça a Vittude: plataforma de terapia online que conecta pacientes e psicólogos no Brasil'

export const generateSearchOfflineH1 = ({
	cityName,
	cityState,
	symptom,
	skill
}) => {
	if (!cityName) {
		return 'Encontre psicólogos e agende consultas de terapia presencial e online na Vittude'
	}

	const location = cityState ? `${cityName}, ${cityState}` : cityName

	if (symptom) {
		return `Psicólogos especializados em ${symptom} em ${location} - Agende consulta de terapia na Vittude`
	}

	if (skill) {
		return `Psicólogos com abordagem ${skill} em ${location} - Encontre profissionais de terapia na Vittude`
	}

	return `Psicólogos em ${location} - Encontre profissionais de terapia presencial e online na Vittude`
}

export const generateSearchOfflineNeighborhoodH1 = ({
	neighborhoodName,
	cityName,
	cityState,
	symptom,
	skill
}) => {
	if (!neighborhoodName || !cityName) {
		return generateSearchOfflineH1({ cityName, cityState, symptom, skill })
	}

	const location = cityState
		? `${neighborhoodName}, ${cityName}, ${cityState}`
		: `${neighborhoodName}, ${cityName}`

	if (symptom) {
		return `Psicólogos especializados em ${symptom} em ${location} - Agende consulta de terapia presencial na Vittude`
	}

	if (skill) {
		return `Psicólogos com abordagem ${skill} em ${location} - Encontre profissionais de terapia na Vittude`
	}

	return `Psicólogos em ${location} - Agende consulta de terapia presencial na Vittude`
}

export const generateH1FromPath = (pathname, context = {}) => {
	if (pathname === '/' || pathname === '') {
		return HOME_H1
	}

	if (pathname === '/faq') {
		return FAQ_H1
	}

	if (pathname === '/quem-somos') {
		return ABOUT_H1
	}

	if (pathname.startsWith('/psicologos/')) {
		const parts = pathname.split('/').filter(Boolean)
		if (parts.length >= 2) {
			const citySlug = parts[1]
			const neighborhoodSlug = parts[2]

			if (neighborhoodSlug) {
				return generateSearchOfflineNeighborhoodH1({
					neighborhoodName: context.neighborhoodName || neighborhoodSlug,
					cityName: context.cityName || citySlug,
					cityState: context.cityState,
					symptom: context.symptom,
					skill: context.skill
				})
			}

			return generateSearchOfflineH1({
				cityName: context.cityName || citySlug,
				cityState: context.cityState,
				symptom: context.symptom,
				skill: context.skill
			})
		}
	}

	return 'Encontre psicólogos e agende consultas de terapia online na Vittude'
}

